import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import theme from 'theme/ThemeContext';

const CustomCheckbox = ({ label, sx, ...props }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          {...props}
          sx={{
            // color: theme.palette.primary.main,
            '&.Mui-checked': {
              color: theme.palette.primary.main || theme.palette.primary.main,
            },
            ...sx,
          }}
        />
      }
      label={label}
    />
  );
};

export default CustomCheckbox;
